import { useEffect } from 'react';
import * as Sentry from '@sentry/react';

import LandingPageLayout from 'src/components/reusable-components/landing-page-layout';
import Spinner from 'src/components/spinner';
import { getHelpCenterRedirectUrl } from 'src/utils/helpCenterAuthUtils';

/**
 * Landing page after Zendesk sign-in completes. The user arrives here at
 * `<subdomain>.${ZENDESK_DOMAIN}/forethought/dashboard/hc-redirect?return_to=<hc-url>`
 * authenticated via ZD SSO. We swap the ZD session for a JWT-bearing
 * helpcenter URL (preserving `return_to`) and forward the browser there.
 */
export default function HcRedirect() {
  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const redirectUrl = await getHelpCenterRedirectUrl();
        if (!cancelled) {
          window.location.href = redirectUrl;
        }
      } catch (err) {
        Sentry.captureException(err);
        if (!cancelled) {
          window.location.href = '/';
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <LandingPageLayout>
      <Spinner />
    </LandingPageLayout>
  );
}
